import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";

import Topbar from "../../shared/components/topbar/Topbar";
import { printerActions, systemActions } from "../../redux/actions";
import Button from "../../shared/components/Buttons/Button";
import {
  toastType,
  toastMessages,
  printerConstants,
  buttonNameConstants,
  buttonTypeConstants,
  inventoryConstants,
} from "../../constants";
import {
  disconnectFromQZTray,
  getPrintersListFromQz,
  printTestReceiptData,
} from "../../shared/Printers/ReceiptPrinters/printReceipt";
import {
  customToast,
  generateUuid,
  isEmployeeLogin,
  getIsHideNonInventoryOptions,
  isSpinnerEnabled,
} from "../../shared/utility";
import {
  testCashDrawer,
  testReceiptPrintDesign,
} from "../../shared/Printers/ReceiptPrinters/testPrintDesign";
import { testZebraPrintDesign } from "../../shared/Printers/ZebraPrinter/testZebraPrintDesign";
import PirnterDropdown from "../../shared/components/selectDropdown/PirnterDropdown";
import {
  setItemToLocalStorage,
  getItemFromLocalStorage,
} from "../../system/storage";
import { sentryLogError } from "../../system/sentry";

const PrinterSettings = (props) => {
  const {
    user,
    currentStore,
    printer,
    spinnerArray,
    addNewPrinter,
    activateSpinner,
    deactivateSpinner,
  } = props;

  const isHideNonInventoryOptions = getIsHideNonInventoryOptions(
    props.currentStore
  );

  //------printer reducer
  const { defaultZebraPrinter, defaultReceiptPrinter } = printer;

  //-------usestate
  const [allSystemAvailablePrinters, setAllSystemAvailableReceiptPrinters] =
    useState([]);

  //-------get all receipt printers
  const getAllReceiptPrinters = async () => {
    try {
      const printerList = await getPrintersListFromQz();
      setAllSystemAvailableReceiptPrinters(printerList);
    } catch (error) {
      customToast(error?.message, toastType.ERROR);
      sentryLogError(error?.toString());
    } finally {
      await disconnectFromQZTray();
    }
  };

  //-------handle add print
  const handleAddPrinterSubmit = (values, printerType) => {
    let localDeviceIp = getItemFromLocalStorage(
      printerConstants.LOCAL_DEVICE_IP
    );
    if (!localDeviceIp) {
      localDeviceIp = generateUuid();
      setItemToLocalStorage(printerConstants.LOCAL_DEVICE_IP, localDeviceIp);
    }

    if (currentStore) {
      const data = {
        printerName: values.label,
        printerType: printerType,
        isDefault: true,
        localDeviceIp,
        generalSettings: {
          vendorId: "NoNeed",
          productId: "NoNeed",
          productName: values.label,
          serialNumber: "NoNeed",
          manufacturerName: "NoNeed",
          DeviceType: "NoNeed",
        },
        store: {
          id: currentStore?.id,
          name: currentStore?.storeName,
        },
      };
      addNewPrinter(data, currentStore?.id);
    }
  };

  //-------handle test receipt print
  const handleReceiptTestPrint = () => {
    if (defaultReceiptPrinter) {
      printTestReceiptData(
        defaultReceiptPrinter.printerName,
        testReceiptPrintDesign(),
        activateSpinner,
        deactivateSpinner
      );
    } else {
      customToast(
        toastMessages.PLEASE_SET_DEFAULT_RECEIPT_PRINTER,
        toastType.ERROR
      );
    }
  };

  //-------Test Cash Drawer Open
  const handleTestCashDrawerClick = () => {
    if (defaultReceiptPrinter) {
      printTestReceiptData(
        defaultReceiptPrinter.printerName,
        testCashDrawer(),
        activateSpinner,
        deactivateSpinner
      );
    } else {
      customToast(
        toastMessages.PLEASE_SET_DEFAULT_RECEIPT_PRINTER,
        toastType.ERROR
      );
    }
  };

  //-------handle test zebra print
  const handleZebraTestPrint = () => {
    if (defaultZebraPrinter) {
      printTestReceiptData(
        defaultZebraPrinter.printerName,
        testZebraPrintDesign,
        activateSpinner,
        deactivateSpinner
      );
    } else {
      customToast(
        toastMessages.PLEASE_SET_DEFAULT_ZEBRA_PRINTER,
        toastType.ERROR
      );
    }
  };

  useEffect(() => {
    getAllReceiptPrinters();
  }, []);

  return (
    <>
      <Topbar title="Printer Settings"></Topbar>
      <Row className="m-0">
        {!isHideNonInventoryOptions && (
          <Col md={9} className="d-flex align-items-center gap-3 mb-4">
            <Row className="m-0 w-100">
              <Col md={2} className="d-flex align-items-center">
                <span className="text-nowrap">Receipt Printer</span>
              </Col>
              <Col md={6} className="d-flex align-items-center">
                <PirnterDropdown
                  printerType="Receipt"
                  isSearchable={false}
                  defaultPrinter={defaultReceiptPrinter}
                  placeholder={"Select Receipt Printer..."}
                  options={allSystemAvailablePrinters?.map((printer) => {
                    return {
                      value: printer?.id,
                      label: printer?.printerName,
                    };
                  })}
                  handleChange={(e) =>
                    handleAddPrinterSubmit(e, printerConstants.RECEIPT_PRINTER)
                  }
                />
              </Col>
              <Col md={2} className="d-flex align-items-center">
                <Button
                  className={"text-start"}
                  label={buttonNameConstants.PRINT_TEST_RECEIPT}
                  buttonType={buttonTypeConstants.TRANSPARENT_BUTTON_PURPLE}
                  handleClick={handleReceiptTestPrint}
                  isDisabled={isSpinnerEnabled(
                    spinnerArray,
                    inventoryConstants.LABELS_PRINTING
                  )}
                />
              </Col>{" "}
              <Col md={2} className="d-flex align-items-center">
                {!isEmployeeLogin(user) && (
                  <Button
                    className={"text-start"}
                    label={buttonNameConstants.TEST_CASH_DRWAER}
                    buttonType={buttonTypeConstants.TRANSPARENT_BUTTON_PURPLE}
                    handleClick={handleTestCashDrawerClick}
                    isDisabled={isSpinnerEnabled(
                      spinnerArray,
                      inventoryConstants.LABELS_PRINTING
                    )}
                  />
                )}
              </Col>
            </Row>
          </Col>
        )}
        <Col md={9} className="d-flex align-items-center gap-3">
          <Row className="m-0 w-100">
            <Col md={2} className="d-flex align-items-center">
              <span className="text-nowrap">Label Printer</span>
            </Col>
            <Col md={6} className="d-flex align-items-center">
              <PirnterDropdown
                printerType="Label"
                isSearchable={false}
                defaultPrinter={defaultZebraPrinter}
                placeholder={"Select Label Printer..."}
                options={allSystemAvailablePrinters?.map((printer) => {
                  return {
                    value: printer?.id,
                    label: printer?.printerName,
                  };
                })}
                handleChange={(e) =>
                  handleAddPrinterSubmit(e, printerConstants.ZEBRA_PRINTER)
                }
              />
            </Col>
            <Col md={2} className="d-flex align-items-center">
              <Button
                className={"text-start"}
                label={buttonNameConstants.PRINT_TEST_LABEL}
                buttonType={buttonTypeConstants.TRANSPARENT_BUTTON_PURPLE}
                handleClick={handleZebraTestPrint}
                isDisabled={isSpinnerEnabled(
                  spinnerArray,
                  inventoryConstants.LABELS_PRINTING
                )}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  printer: state.printer,
  user: state.authentication.user,
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  addNewPrinter: (data, storeId) =>
    dispatch(printerActions.addNewPrinter(data, storeId)),
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(PrinterSettings);
